module.exports = __webpack_public_path__ + "img/steinbuehl_tafelbild.512b88c9.jpg";